<template>
    <div class="float-left mr-1">
        <b-button variant="info" @click.stop="confirmarResponsaveisPadrao()">
            <span>Responsáveis Padrão</span>
        </b-button>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarResponsaveisPadrao() {
            this.$swal({
                title: 'Responsáveis pelo Contrato',
                html: `Confirma a inserção dos responsáveis padrão no contrato <b>${this.contrato.vcCodigoEstruturado} - ${this.contrato.fornecedor.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarResponsaveisPadrao()
                }
            })
        },

        salvarResponsaveisPadrao() {
            this.$store.dispatch('addRequest')
            ContratosServicos.inserirResponsaveisPadrao(
                this.contrato.idContrato
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro salvo com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterResponsaveisAtualizados')
                    } else {
                        this.$toast.error(
                            'Falha ao inserir responsáveis padrão!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
